import { AlertTight } from "@/Components/v2/atoms/Alert/AlertTight";
import { InfoOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";

const STORAGE_KEY = "actionPlansNewRecommendationsBannerDismissed";
const FIRST_SEEN_KEY = "actionPlansNewRecommendationsBannerFirstSeen";
// 7 days in milliseconds
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

const NewRecommendations: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if manually dismissed
    const isDismissed = localStorage.getItem(STORAGE_KEY) === "true";
    if (isDismissed) return;

    // Check first seen date
    const firstSeenStr = localStorage.getItem(FIRST_SEEN_KEY);
    const now = Date.now();

    // First time seeing the banner, store the timestamp
    if (!firstSeenStr) {
      localStorage.setItem(FIRST_SEEN_KEY, now.toString());
      setIsVisible(true);
      return;
    }

    // Banner was seen before, check if 7 days have passed
    const firstSeen = parseInt(firstSeenStr, 10);
    const daysSinceFirstSeen = now - firstSeen;

    if (daysSinceFirstSeen < SEVEN_DAYS_MS) {
      // Within 7 days, show the banner
      setIsVisible(true);
      return;
    }
    // 7 days have passed, auto-dismiss permanently
    localStorage.setItem(STORAGE_KEY, "true");
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  // Don't render if dismissed
  if (!isVisible) {
    return null;
  }

  return (
    <AlertTight
      icon={<InfoOutlined sx={{ color: "#00A953" }} />}
      title="New recommendations available!"
      text="We've automatically generated some new recommended scenarios for your Action Plans. View your currently active plans for more information."
      textColor="#131313"
      closeIconColor="black"
      sx={{ backgroundColor: "#E9F8F0" }}
      onClose={handleClose}
    />
  );
};

export default NewRecommendations;
